import {
  CLEAR_TIFD_REPORT,
  FILL_TIFD_WORKBOOK_FAILURE,
  FILL_TIFD_WORKBOOK_REQUEST,
  FILL_TIFD_WORKBOOK_SUCCESS,
  GET_TIFD_REPORT_FAILURE,
  GET_TIFD_REPORT_REQUEST,
  PREVIEW_TIFD_REPORT_FAILURE,
  PREVIEW_TIFD_REPORT_REQUEST,
  PREVIEW_TIFD_REPORT_SUCCESS,
} from './constants';
import { TifdAction, TifdState } from './types';

const initialState: TifdState = {
  loading: false,
  report: null,
  context: null,
  workbookLoading: false,
};

export const tifdReducer = (
  state = initialState,
  action: TifdAction
): TifdState => {
  switch (action.type) {
    case PREVIEW_TIFD_REPORT_REQUEST:
    case GET_TIFD_REPORT_REQUEST:
      return { ...state, loading: true, error: undefined };
    case PREVIEW_TIFD_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        report: action.payload.report,
        context: action.payload.context,
      };
    case PREVIEW_TIFD_REPORT_FAILURE:
    case GET_TIFD_REPORT_FAILURE:
      return { ...state, loading: false, error: 'load-failed' };
    case FILL_TIFD_WORKBOOK_REQUEST:
      return { ...state, workbookLoading: true };
    case FILL_TIFD_WORKBOOK_SUCCESS:
    case FILL_TIFD_WORKBOOK_FAILURE:
      return { ...state, workbookLoading: false };
    case CLEAR_TIFD_REPORT:
      return initialState;
    default:
      return state;
  }
};
